// ThemeConstants.js
export const isBidnaaTheme = () => document.body.className == 'MultiSeller_two bidNaa'
export const isHawaiiTheme = () => document.body.classList[1] == 'hawaii'
export const isBargainsTheme = () => global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
